import { INFORMATION_MENU_COMMUNITY, INFORMATION_MENU_NOTICE } from '@/constants/information';
import { positionOptions } from '@/constants/option';
import {
	PAYMENT_CONFERENCE_POSITION_GRADUATE,
	PAYMENT_CONFERENCE_POSITION_PROFESSOR,
	PAYMENT_CONFERENCE_POSITION_UNDERGRADUATE,
	PAYMENT_MEMBER_BOARD,
	PAYMENT_MEMBER_LIFETIME,
	PAYMENT_MEMBER_REGULAR,
	PAYMENT_MEMBER_STUDENT,
} from '@/constants/payment';

export const convertInfoValue = (value: string) => {
	switch (value) {
		case '공지사항':
		case INFORMATION_MENU_NOTICE:
			return 'notice';
		case '소식지':
			return 'newsletter';
		case '연구동향':
			return 'trend';
		case '갤러리':
			return 'gallery';
		case '자유게시판':
		case INFORMATION_MENU_COMMUNITY:
			return 'forum';
		default:
			return 'notice';
	}
};

export const convertPaymentValue = (value: string) => {
	switch (value) {
		case PAYMENT_MEMBER_LIFETIME:
			return '300,000';
		case PAYMENT_MEMBER_BOARD:
			return '100,000';
		case PAYMENT_MEMBER_REGULAR:
			return '50,000';
		case PAYMENT_MEMBER_STUDENT:
			return '20,000';
		default:
			return '0';
	}
};

export const convertConferencePaymentValue = (value: string) => {
	switch (value) {
		case PAYMENT_CONFERENCE_POSITION_PROFESSOR:
			return '80,000';
		case PAYMENT_CONFERENCE_POSITION_GRADUATE:
			return '50,000';
		case PAYMENT_CONFERENCE_POSITION_UNDERGRADUATE:
			return '20,000';
		default:
			return '80,000';
	}
};

export const convertPublicationPaymentValue = (value: string) => {
	switch (value) {
		case '기본':
			return '400,000';
		case '속보':
			return '600,000';
		default:
			return '400,000';
	}
};

export const convertPositionValue = (value: string) => {
	const match = positionOptions.find((option) => option.value === value);
	return match ? match.value : '기타(직접입력)';
};
